/**
 * Predefined report card definitions (Australian copy)
 */

import type { ReportDefinition } from '../types/report.types';

export const REPORT_DEFINITIONS: ReportDefinition[] = [
  {
    type: 'monthly_financial_summary',
    title: 'Financial Summary',
    description: 'Complete overview of income, expenses and savings for your selected period',
    icon: 'Calendar',
    features: [
      'Income vs expenses analysis',
      'Category spending breakdown',
      'Budget performance tracking',
      'Month-over-month comparison',
    ],
  },
  {
    type: 'tax_deduction',
    title: 'Tax Deduction Report',
    description: 'Tax-deductible expenses organised by ATO theme',
    icon: 'Receipt',
    features: [
      'Work-related expenses',
      'Gifts and donations summary',
      'Cost of managing tax affairs',
      'Home office and motor vehicle deductions',
    ],
  },
  {
    type: 'business_expense',
    title: 'Business Expense Report',
    description:
      'Business-only expenses from your Business Expenses category tree, with GST and transaction detail',
    icon: 'Briefcase',
    features: [
      'Totals for Business Expenses categories only',
      'Category breakdown and travel/motor vehicle slice',
      'GST summary on business transactions (where applicable)',
      'Itemised business transactions included by default',
    ],
  },
  {
    type: 'category_spending_analysis',
    title: 'Category Spending Analysis',
    description: 'Detailed breakdown of spending by category',
    icon: 'PieChart',
    features: [
      'Top spending categories',
      'Percentage allocation',
      'Trend analysis over time',
      'Budget vs actual comparison',
    ],
  },
  {
    type: 'year_end_tax_summary',
    title: 'Year-End Tax Summary',
    description: 'Comprehensive annual tax preparation report',
    icon: 'FileText',
    features: [
      'PAYG and salary income summary',
      'Deductible expense totals',
      'Investment gains and losses (CGT-oriented)',
      'Informational BAS/PAYG instalment summary',
    ],
  },
  {
    type: 'profit_and_loss',
    title: 'Profit & Loss Statement',
    description: 'Business financial performance overview',
    icon: 'LineChart',
    features: [
      'Revenue and income streams',
      'Operating expense breakdown',
      'Net profit calculation',
      'Period-over-period comparison',
    ],
  },
];

export function getReportDefinition(type: string): ReportDefinition | undefined {
  return REPORT_DEFINITIONS.find((d) => d.type === type);
}
